import React, { useCallback, useState } from 'react';

import { clearFields } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/helpers';
import { RenderForm } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/RenderForm';
import { RenderSelectTheme } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/RenderSelectTheme';
import {
    IInputValue,
    INITIAL_THEME,
    ITheme,
    THEMES,
    TSendRequestHandle,
} from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/types';
import { useIsValidForm } from '@r1-frontend/ui-react/organisms/Footer/components/CallRequestByTheme/useIsValidForm';

import { Popup } from './styled';

interface CallRequestByThemeProps {
    isOpen: boolean,
    onClose: () => void,
    sendRequestHandle: TSendRequestHandle,
    policyLink: string,
    onChangeHandle: (theme: ITheme) => void,
    openChatHandler: () => void,
}

export const CallRequestByTheme = ({
    openChatHandler,
    isOpen,
    onClose,
    sendRequestHandle,
    onChangeHandle,
    policyLink,
}: CallRequestByThemeProps) => {
    const [theme, setTheme] = useState<ITheme>(THEMES[INITIAL_THEME]);
    const [selectBlockVisible, setVisible] = useState<boolean>(true);
    const [isHighlight, setHighlight] = useState<number>(INITIAL_THEME);
    const [fio, setFio] = useState<IInputValue>({ value: '', isValid: false });
    const [phone, setPhone] = useState<IInputValue>({ value: '', isValid: false });
    const [clearTimeoutLink, setClearTimeout] = useState<number | null>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);
    const [message, setMessage] = useState<string | null | undefined>(null);

    const [isValid] = useIsValidForm(fio, phone);


    // @TODO заплатка - потому что clearFields не очищает phone
    const clearFieldsPatch = () => {
        setFio({ value: '', isValid: false });
        setPhone({ value: '', isValid: false });
    };

    const handleClose = useCallback(() => {
        setVisible(true);
        setHighlight(INITIAL_THEME);
        setIsError(false);
        setMessage(null);
        clearFields([fio, phone]);
        clearFieldsPatch();
        if (clearTimeoutLink) {
            clearTimeout(clearTimeoutLink);
        }
        onClose();
    }, [fio, phone, clearTimeoutLink, onClose]);

    const handleSendRequest = useCallback(async() => {
        if (theme) {
            setIsError(false);
            setMessage(null);
            if (clearTimeoutLink) {
                clearTimeout(clearTimeoutLink);
            }
            setIsLoading(true);
            setMessage(null);

            const resp = await sendRequestHandle({
                theme,
                fioValue: fio.value,
                phoneValue: phone.value,
            });

            clearFields([fio, phone]);
            clearFieldsPatch();

            setIsLoading(false);
            setIsError(resp.isError);
            setMessage(resp.message);
            setClearTimeout(Number(setTimeout(() => {
                setIsError(false);
                setMessage(null);
            }, 30000)));
        }
    }, [theme, clearTimeoutLink, sendRequestHandle, fio, phone]);

    const onSelectHandler = (theme: ITheme, index: number) => {
        setVisible(false);
        setTheme(theme);
        setHighlight(index);
    };

    const onChangeHandler = () => {
        setVisible(true);
        clearFieldsPatch();
    };

    return <Popup isOpen={isOpen} onClose={handleClose}>
        {
            selectBlockVisible
                ? <RenderSelectTheme
                    themes={THEMES}
                    highlightIndex={isHighlight}
                    onSelectTheme={onSelectHandler}/>
                : <RenderForm
                    fio={fio}
                    onChangeTheme={onChangeHandler}
                    onEditFio={setFio}
                    onEditPhone={setPhone}
                    message={message}
                    onSendRequest={handleSendRequest}
                    phone={phone}
                    theme={theme}
                    isValid={isValid}
                    isLoading={isLoading}
                    isError={isError}
                    policyLink={policyLink}
                    onChangeHandle={onChangeHandle}
                    openChatHandler={openChatHandler}
                />
        }
    </Popup>;
};


